<template>
  <v-toolbar color="#32b6ec" flat min-height="107px" id="search-bar" v-if="display" prominent >
    <v-container align-center justify-center fill-height width="100%">
      <v-text-field
            id="search-input"
            placeholder="Busca usuarios por ID de asegurado, nombre o teléfono"
            single-line
            @keyup="search"
            v-model="input"
            color="white"
            dark
            class="white--text"
          ></v-text-field>
    </v-container>
  </v-toolbar>
</template>

<script>
  export default {
    name: 'SearchBar',

    props: {

      display: {
        type: Boolean,
        default: true
      }
    },

    data () {
      return {
        input: ''
      }
    },

    methods: {

      search () {
        if (this.$route.name === 'AllUsers') {
          this.$store.commit('users/setSearch', this.input);
        }
      },

    },
    
    watch: {
      '$route' (to,from) {
        if (from.name === 'AllUsers') {
          this.input = ''
          this.$store.commit('users/setSearch', null);
        }

      }
    }

  }
</script>

<style scoped lang="scss">

  #search-bar {
    width: 100%;
    position: absolute;
    z-index: 300;
  }

  #search-input  {
    color: red !important;
  }

  ::v-deep #search-input::placeholder {
    color: white;
  }

</style>